import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaymentApi } from "../Apis/PaymentApi";
import Loader from "./Loader";
import { getStoredConfiguration } from "../util";

function CompletitionBoxMsg(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toPay, setToPay] = useState(props.pay);

  const click = () => {
  }

  const onPay = () => {
    const configuration = getStoredConfiguration();

    /* if (siteUrl.data?.current.siteUrl.toLowerCase().includes("brigaalta")) {
      window.open(
        'https://www.servizipubblicaamministrazione.it/servizi/portalecontribuente/AreaPagamenti.aspx?iddominio=00553180043', "_blank"
      );
    } else  */
    
    if (configuration?.data.current.siteUrl.toLowerCase().includes("camporosso")) {
      window.open(
        'https://www.halleyweb.com/c008011/po/po_login.php', "_blank"
      );
    } else if (configuration?.data.current.siteUrl.toLowerCase().includes("tiglieto")) {

      window.open(
        'https://www.halleyweb.com/c010061/po/po_login.php', "_blank"
      );
    } /*  else if (siteUrl?.data.current.siteUrl.toLowerCase().includes("brugnato")) {

      window.open(
        'https://www.halleyweb.com/c011007/po/po_login.php', "_blank"
      );
    }else if (siteUrl?.data.current.siteUrl.toLowerCase().includes("levanto")) {

      window.open(
        'https://halleyweb.com/c011017/po/po_login.php', "_blank"
      );
    } */
    // console.log("props", props);
    const serviceId = props?.serviceId || props?.fileN?.split("-")?.[0]
    const currentService = configuration?.data?.current?.services?.find(service => service?.id === serviceId);
    // console.log("currentService", currentService, serviceId, props)
    navigate(`/payment-page${currentService?.path ? `?service=${currentService?.path}` : ""}`, { state: { data: props } });
    // window.location.reload(); 
  }

  const onUpdatePaymentState = async () => {
    // console.log("payment status", props);
    try {
      setLoading(true);
      const response = await PaymentApi.updatePaymentState({
        id: props.payID,
        iuv: props.iuv,
        type: props.type
      });

      // console.log("response payment", response?.data);
      setToPay(!response.data.StatoPagamento);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }

  const externalSiteCheck = () => {
    if (props?.link?.includes("levanto")) {
        return `${`https://comune.levanto.sp.it/` + props.link.substring(27, props.link.length)}`;
    }
    else if (props?.link?.includes("riccodelgolfo")) {
        return `${`https://www.comune.riccodelgolfo.sp.it/` + props.link.substring(33, props.link.length)}`;
    }
    else
        return props?.link;
  }

  return (
    <div className="accordion-item" onClick={click}>
      <div className="accordion-header" id="heading7">

        <div>
          <button
            className="accordion-button collapsed title-snall-semi-bold"
            type="button"
            onClick={() => setOpen(prev => !prev)}
          >
            <div className="button-wrapper">
              {props.title}
              <div className="icon-wrapper">

                {
                  toPay ?
                    <>
                      <img
                        className="icon-folder"
                        src={props?.state === "In corso di pagamento" ? "../assets/images/folder-to-in-progress.svg" : "../assets/images/folder-to-pay.svg"}
                        alt="folder Da pagare"
                      />
                      <span className={props?.state === "In corso di pagamento" ? "u-main-inprogress" : "u-main-error"}>{props?.state === "In corso di pagamento" ? " Pagamento in corso di verifica" : " Da pagare"}</span>
                    </> :
                    <>
                      <img
                        className="icon-folder"
                        src="../assets/images/folder-pay.svg"
                        alt="folder Pagato"
                      />
                      <span className="">Pagato</span>
                    </>
                }
              </div>
            </div>
          </button>
          <p className="accordion-date title-xsmall-regular mb-0">
            {toPay && `Data generazione del pagamento:  ${props.date}`}
            {!toPay && `Data del pagamento:  ${props.date}`}
          </p>
        </div>
        {
          open &&
          <div>
            <div className="accordion-body">
              <p className="mb-2 fw-normal">Pagamento:
                <span className="label"> {props?.fileN?.toUpperCase()}</span>
              </p>
              {
                props.iuv &&
                <p className="mb-2 fw-normal">
                  Numero avviso: <span className="label"> {props.iuv}</span>
                </p>
              }
              <p className="mb-2 fw-normal">
                Metodo: <span className="label"> {props.paymentMethod ? props.paymentMethod : (props?.state === "In corso di pagamento" ? "PagoPA" : "Non settato")}</span>
              </p>
              <p className="mb-2 fw-normal">
                Importo: <span className="label"> {props.amount}€</span>
              </p>
              <a style={{ marginRight: "10px" }} href={externalSiteCheck()} className="mb-2">
                <span className="t-primary">
                  Scheda servizio
                </span>
              </a>
              {
                toPay &&
                !props.serviceLink.includes("imu") &&
                <>
                  <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-55%,-50%)", zIndex: "10000" }}>
                    <Loader loading={loading} />
                  </div>
                  {props.state !== "In corso di pagamento" &&
                  <button
                    onClick={onPay}
                    style={{ padding: "8px", background: "var(--primary)" }}
                    type="button"
                    className="btn btn-icon btn-re square"
                    data-focus-mouse="false">Vai al pagamento
                  </button>}
                  {
                    props.iuv && props?.type !== "ypnos" &&
                    <button
                      onClick={onUpdatePaymentState}
                      style={{ padding: "8px", background: "white", color: "var(--primary)", boxShadow: "0 .3px 2px grey", marginTop: ".5rem" }}
                      type="button"
                      className="btn btn-icon btn-re square"
                      data-focus-mouse="false">Aggiorna lo stato del pagamento
                    </button>
                  }
                </>
              }
            </div>
          </div>
        }
      </div>

    </div>
  )
}

export default CompletitionBoxMsg;